import type { NotificationPreferenceSaveEventData } from '@seek/hirer-notification-preference';
import type { SaveJobAccessAndNotifyTrackingData } from '@seek/hirer-team-member-job-access';

import {
  backFromSetTeamEmailStep,
  clickProgressPoint,
  clickSaveJobAccessAndNotify,
  clickSaveOwnPreferences,
  IMPRESSION_ADD_TEAM,
  notificationSettingsImpressionEvent,
} from 'src/app/analytics/notifications';
import getTrackingAdapter from 'src/app/dataAnalytics';
import {
  NOTIFICATIONS_TEAM_EMAIL_BACK_BTN_PRESSED,
  NOTIFICATION_WIDGET_ADD_TEAM_DISPLAYED,
} from 'src/app/dataAnalytics/schema/constants';
import { sendLinkEvent } from 'src/app/utils/analytics';
import type { Tealium } from 'src/types/appState';

export const sendSaveNotificationPreferenceEvent = (
  tealium: Tealium,
  data: NotificationPreferenceSaveEventData,
) => {
  sendLinkEvent(tealium, {
    ...clickSaveOwnPreferences(),
    ...data,
  });
};

export const sendSetTeamEmailBackEvent = (
  tealium: Tealium,
  isPageAnalyticsEnabled: boolean,
) => {
  if (isPageAnalyticsEnabled) {
    const eventData = {
      eventName: NOTIFICATIONS_TEAM_EMAIL_BACK_BTN_PRESSED,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  } else {
    sendLinkEvent(tealium, backFromSetTeamEmailStep());
  }
};

export const sendSaveTeamMemberAccessNotifyEvent = (
  tealium: Tealium,
  data: SaveJobAccessAndNotifyTrackingData,
) => {
  sendLinkEvent(tealium, clickSaveJobAccessAndNotify(data));
};

export const sendOnProgressPointClick = (
  tealium: Tealium,
  fromStepIndex: number,
  toStepIndex: number,
  isPageAnalyticsEnabled: boolean,
) => {
  if (isPageAnalyticsEnabled) {
    const eventData = {
      eventName: `notifications_nav_from_step_${fromStepIndex}_to_${toStepIndex}_pressed`,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  } else {
    sendLinkEvent(tealium, clickProgressPoint(fromStepIndex, toStepIndex));
  }
};

export const sendNotificationsImpressionEvents = (
  impressionName: string,
  tealium: Tealium,
  isPageAnalyticsEnabled: boolean,
  addTeamMember?: boolean,
) => {
  if (isPageAnalyticsEnabled) {
    const eventData = {
      eventName: impressionName,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  } else {
    sendLinkEvent(tealium, notificationSettingsImpressionEvent(impressionName));
  }

  if (addTeamMember) {
    if (isPageAnalyticsEnabled) {
      const eventData = {
        eventName: NOTIFICATION_WIDGET_ADD_TEAM_DISPLAYED,
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    } else {
      sendLinkEvent(
        tealium,
        notificationSettingsImpressionEvent(IMPRESSION_ADD_TEAM),
      );
    }
  }
};
